import { DeepReadonly, IOption } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export interface IVisas {
  label: string;
  value: string;
}

export const successfullyCompletedCourses: DeepReadonly<IOption[]> = deepFreeze([
  { label: 'High School', value: 'High School' },
  { label: 'A Level', value: 'A Level' },
  {
    label: 'International Baccalaureate diploma',
    value: 'Baccalaureate'
  },
  { label: 'University Foundation', value: 'Foundation' },
  { label: 'Certificate of Higher Education', value: 'CoHE' },
  {
    label: 'Diploma of Higher Education (DipHE)',
    value: 'DipHe'
  },
  { label: 'Higher National Diploma (HND)', value: 'HND' },
  { label: 'Bachelor Degree (UG)', value: 'UG' },
  { label: `Master's Degree (PG)`, value: 'PG' },
  { label: 'Graduate Certificate or Diploma', value: 'GC' },
  {
    label: 'Post Graduate Certificate or Diploma',
    value: 'PGC'
  },
  { label: 'Research Degree', value: 'Research' }
]);

export const visas: DeepReadonly<IVisas[]> = deepFreeze([
  { label: 'Tourist / visitor visa', value: 'Tourist / visitor visa' },
  { label: 'Innovator visa', value: 'Innovator' },
  { label: 'Start-up visa', value: 'Start-up' },
  {
    label: 'Investor / entrepreneur visa (Tier 1)',
    value: 'Investor / entrepreneur visa (Tier 1)'
  },
  {
    label: 'Exceptional talent visa (Tier 1)',
    value: 'Exceptional talent visa (Tier 1)'
  },
  {
    label: 'Graduate Entrepreneur visa (Tier 1)',
    value: 'Graduate Entrepreneur'
  },
  {
    label: 'Long-term work visa (Tier 2)',
    value: 'Long-term work visa (Tier 2)'
  },
  {
    label: 'Short-term work visa (Tier 5)',
    value: 'Short-term work visa (Tier 5)'
  },
  {
    label: 'Intra-company Transfer visa (Tier 2)',
    value: 'Intra-company Transfer'
  },
  {
    label: 'Minister of Religion visa (Tier 2)',
    value: 'Minister of Religion'
  },
  { label: 'Sportsperson visa (Tier 2)', value: 'Sportsperson' },
  { label: 'Low Skilled Worker (Tier 3)', value: 'Low Skilled Worker' },
  { label: 'Standard Visitor visa', value: 'Standard Visitor' },
  { label: 'Marriage Visitor visa', value: 'Marriage Visitor' },
  {
    label: 'Permitted Paid Engagement visa',
    value: 'Permitted Paid Engagement'
  },
  {
    label: 'Parent of a Tier 4 child visa',
    value: 'Parent of a Tier 4 child'
  },
  { label: 'Visit the UK in a Chinese tour group', value: 'Chinese Tour' },
  {
    label: 'Visa to pass through the UK in transit',
    value: 'Pass Through'
  },
  { label: 'Short-term study / student visa', value: 'Short Term' },
  {
    label: 'Student visa (Tier 4 General/Student Route)',
    value: 'Student visa (Tier 4 General/Student Route)'
  },
  {
    label: 'Child Student visa (Tier 4 Child/Child Student Route)',
    value: 'Child Student visa (Tier 4 Child/Child Student Route)'
  },
  {
    label: 'Temporary Worker - Charity Worker visa (Tier 5)',
    value: 'TW - Charity'
  },
  {
    label: 'Temporary Worker - Creative and Sporting visa (Tier 5)',
    value: 'TW - Creative & Sporting'
  },
  {
    label: 'Temporary Worker - Government Authorised Exchange visa (Tier 5)',
    value: 'TW - Gov Auth Exchange'
  },
  {
    label: 'Temporary Worker - International Agreement visa (Tier 5)',
    value: 'TW - Int. Agreement'
  },
  {
    label: 'Temporary Worker - Religious Worker visa (Tier 5)',
    value: 'TW - Religious Worker'
  },
  {
    label: 'Temporary Worker - Seasonal Worker Visa (Tier 5)',
    value: 'TW - Seasonal Worker'
  },
  {
    label: 'Youth mobility scheme visa (Tier 5)',
    value: 'Youth mobility scheme visa (Tier 5)'
  },
  { label: 'Family visas: apply, extend or switch', value: 'Family Visas' },
  {
    label: 'Apply for a permit to join your EU or EEA family member in the UK',
    value: 'EU/EEA Family'
  },
  { label: 'Dependant Visa', value: 'Dependant' },
  { label: 'Other (My visa is not listed here)', value: 'Other' }
]);
